"use client";

import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";

type AnnotationDataContextType = {
  annotationTexts: Record<string, string> | null;
  setAnnotationTexts: (texts: Record<string, string> | null) => void;
};

const AnnotationDataContext = createContext<AnnotationDataContextType | null>(null);

export const AnnotationDataProvider = ({ children }: { children: ReactNode }) => {
  const [annotationTexts, setAnnotationTexts] = useState<Record<string, string> | null>(null);

  return (
    <AnnotationDataContext.Provider value={{ annotationTexts, setAnnotationTexts }}>
      {children}
    </AnnotationDataContext.Provider>
  );
};

export const useAnnotationData = () => {
  const context = useContext(AnnotationDataContext);
  if (!context) {
    throw new Error("useAnnotationData must be used within AnnotationDataProvider");
  }
  return context;
};
